module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile) ? _c('mu-card', {
    attrs: {
      "id": "profileAvatar"
    }
  }, [_c('mu-card-text', [(!_vm.isOwner) ? _c('mu-raised-button', {
    staticClass: "followBtn",
    attrs: {
      "fullWidth": "",
      "primary": "",
      "label": _vm.isProcessFollowing ? 'Processing' : _vm.profile.auth_user_following ? 'Following' : 'Follow',
      "disabled": _vm.isProcessFollowing
    },
    nativeOn: {
      "click": function($event) {
        return _vm.follow()
      }
    }
  }, [(_vm.isProcessFollowing) ? _c('mu-circular-progress', {
    attrs: {
      "size": 24,
      "color": "white"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showPrivacyInfo && _vm.isBirthday) ? _c('p', {
    staticClass: "birthday"
  }, [_c('mu-icon', {
    attrs: {
      "value": "cake"
    }
  }), _vm._v("\n      Happy Birthday!!\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.showPrivacyInfo && _vm.profile.diabetes_type) ? _c('p', {
    staticClass: "diabetesType",
    domProps: {
      "textContent": _vm._s(_vm.profile.diabetes_type)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacyInfo && _vm.profile.bio) ? _c('p', {
    staticClass: "bio preWrap",
    domProps: {
      "textContent": _vm._s(_vm.profile.bio)
    }
  }) : _vm._e(), _vm._v(" "), _c('profile-goals'), _vm._v(" "), (_vm.isOwner) ? _c('div', {
    staticClass: "emptyFields"
  }, _vm._l((_vm.metaFields), function(field, fieldIndex) {
    return _c('div', {
      key: ("meta-field-" + fieldIndex),
      staticClass: "field"
    }, [(field.to === undefined) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.doMetaField(field)
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "add"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(field.label)
      }
    })], 1) : _vm._e(), _vm._v(" "), (field.key === 'bio' && field.toggle) ? _c('add-profile-bio', {
      on: {
        "bioClosed": _vm.onClose
      }
    }) : _vm._e(), _vm._v(" "), (field.key === 'avatar' && field.toggle) ? _c('add-profile-picture', {
      on: {
        "pictureClosed": _vm.onClose
      }
    }) : _vm._e(), _vm._v(" "), (field.key === 'remove-avatar' && _vm.profile.profile_image) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.removeProfilePicture()
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "remove"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(field.label)
      }
    })], 1) : _vm._e(), _vm._v(" "), (field.key === 'cover' && field.toggle) ? _c('add-profile-cover', {
      on: {
        "coverClosed": _vm.onClose
      }
    }) : _vm._e(), _vm._v(" "), (field.key === 'remove-cover' && _vm.profile.cover_photo) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.removeCoverPhoto()
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "remove"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(field.label)
      }
    })], 1) : _vm._e()], 1)
  }), 0) : _vm._e()], 1), _vm._v(" "), (!_vm.showProfileInfo) ? _c('mu-divider') : _vm._e(), _vm._v(" "), (!_vm.showProfileInfo) ? _c('mu-menu', {
    attrs: {
      "desktop": ""
    }
  }, [(_vm.showPrivacyInfo) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelFollowers'),
      "afterText": '' + _vm.profile.followers + ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('ProfileFollowers')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacyInfo) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelFollowing'),
      "afterText": '' + _vm.profile.following + ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('ProfileFollowing')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacyQuestions) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelQuestionsAnswered'),
      "afterText": '' + _vm.profile.answers + ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('ProfileDiscussion')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPrivacyQuestions) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelQuestionsAsked'),
      "afterText": '' + _vm.profile.questions + ''
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('ProfileDiscussion')
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "profileProgress"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('message.labelProgramProgress')))]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": false
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "tablet": "80",
      "desktop": "80"
    }
  }, [_c('mu-linear-progress', {
    attrs: {
      "mode": "determinate",
      "size": 15,
      "value": _vm.profile.progress.percentage,
      "min": 0,
      "max": 100,
      "color": _vm.profile.progress.colour
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "15",
      "tablet": "15",
      "desktop": "15"
    }
  }, [_c('span', {
    staticClass: "percentage",
    domProps: {
      "textContent": _vm._s(((_vm.profile.progress.percentage) + "%"))
    }
  })])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-208824fd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/ProfileAvatar/ProfileAvatar.vue
// module id = 3630
// module chunks = 1